import {
  ConeGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Brand mesh — fire pillar silhouette cue (OCP registry). */
export function createBrandMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0xea580c : 0xb91c1c;
  const bodyMat = new MeshStandardMaterial({ color: 0x292524, roughness: 0.6 });
  const fireMat = new MeshStandardMaterial({ color: trim, roughness: 0.35, emissive: trim, emissiveIntensity: 0.25 });

  const torso = new Mesh(new CylinderGeometry(0.7, 0.55, 2.1, 10), bodyMat);
  torso.position.y = 1.9;
  group.add(torso);

  const head = new Mesh(new SphereGeometry(0.42, 12, 12), fireMat);
  head.position.y = 3.2;
  group.add(head);

  const flame = new Mesh(new ConeGeometry(0.35, 1.1, 8), fireMat);
  flame.position.set(0, 3.9, 0);
  group.add(flame);

  const staff = new Mesh(new CylinderGeometry(0.06, 0.08, 2.2, 8), bodyMat);
  staff.position.set(0.8, 1.7, 0.15);
  group.add(staff);

  const ember = new Mesh(new SphereGeometry(0.2, 8, 8), fireMat);
  ember.position.set(0.8, 2.95, 0.15);
  group.add(ember);

  return group;
}
